<template>
  <div class="app-container">
    <viewForm ref="viewForm" :is-edit="false" @submit="submit" />
  </div>
</template>
<script>
import { userApi } from '@/api';
import viewForm from './components/viewForm';
export default {
  name: 'BusinessUserAccountAdd',
  components: {
    viewForm,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    submit(data) {
      // 判断添加的是用户还是客户
      userApi['createUser']({
          ...data,
        })
        .then(res => {
          if (res.realName) {
            const msg = ` ${res.realName} ${this.$t('toast.login')} ${res.loginName}`;
            this.$alert(msg, this.$t('toast.operationSuccessText'), {
              confirmButtonText: this.$t('toast.okText'),
              callback: () => {
                this.$refs.viewForm.complete({ name: 'BusinessUserAccount' });
              },
            });
          }
        });
    },
  },
};
</script>
<style scoped></style>
